import { IRootState } from '../../../store'
import { IExposureOptionsState } from '../store/options.types'

export const getExposureOptionsSelector = (state: IRootState): IExposureOptionsState => state.options.exposureOptions
